import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import Relation from "../../../../shared-module/model/relation.model";
import Subscription from "../../../../shared-module/model/subscription.model";
import {AuthService} from "../../../../shared-module/services/auth.service";
import {ButtonComponent} from "../../../../shared-module/components/button/button.component";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import ModalService from "../../../../shared-module/services/modal.service";
import {SuccessModalComponent} from "../../../../shared-module/components/success-modal/success-modal.component";
import TicketStore from "../../../../shared-module/services/Stores/ticket.store";
import {Ticket} from "../../../../shared-module/model/ticket.model";
import {Router} from "@angular/router";
import {config} from "../../../../../config";
import {
  CountableTextareaComponent
} from "../../../../shared-module/components/countable-textarea/countable-textarea.component";

import {
  SubscriptionSelectorComponent
} from "../../../../shared-module/components/subscription-selector/subscription-selector.component";

@Component({
    selector: 'app-ticket-new',
    imports: [
    ButtonComponent,
    ReactiveFormsModule,
    CountableTextareaComponent,
    SubscriptionSelectorComponent
],
    templateUrl: './ticket-new.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './ticket-new.component.scss'
})
export class TicketNewComponent implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly modalService: ModalService = inject(ModalService);
  private readonly ticketStore: TicketStore = inject(TicketStore);
  private readonly router: Router = inject(Router);

  protected subscriptionCount: number = 0;
  private currentRelation: Relation | null = null;
  private currentSubscription: Subscription | null = null;

  public form: FormGroup = new FormGroup({
    textarea: new FormControl('', [
      Validators.required,
      Validators.minLength(config.support.textMinCharacterCount),
      Validators.maxLength(config.textMaxCharacterCount)
    ])
  });

  public ngOnInit(): void {
    this.authService.getUser(['relations.subscriptions,relations.tickets']).subscribe();

    this.authService.getActiveRelation().subscribe((relation: Relation | null): void => {
      if (!relation) {
        return;
      }
      this.currentRelation = relation;
      this.subscriptionCount = relation.subscriptions ? relation.subscriptions.length : 0;
    });

    this.authService.getSelectedSubscription().subscribe((subscription: Subscription | null): void => {
      if (!subscription) {
        return;
      }

      this.currentSubscription = subscription;
    });
  }

  public setCurrentSubscription(subscription: Subscription): void {
    this.currentSubscription = subscription;
  }

  public submit(): void {
    if (this.form.invalid) {
      return;
    }
    if (!this.currentRelation || !this.currentSubscription) {
      return;
    }

    const regex: RegExp = /(<([^>]+)>)/ig;
    const newTicketToSend: Ticket = new Ticket();

    newTicketToSend.relation_id = this.currentRelation.id;
    newTicketToSend.subscr_id = this.currentSubscription.id;
    newTicketToSend.description = this.form.controls['textarea'].value.replace(regex, "");

    this.ticketStore.create(newTicketToSend, {
      include: 'messages.relation_contact'
    }).subscribe((newTicket: Ticket) => {
      this.modalService.open(SuccessModalComponent, null, {
        title: 'Bericht verstuurd!',
        subtitle: 'We hebben je bericht in goede orde ontvangen! We komen zo snel mogelijk bij je terug.',
        width: '550px',
        showCloseButton: true,
      });

      if (this.currentRelation) {
        this.currentRelation.tickets.push(newTicket);
      }

      //redirect to the new ticket
      this.router.navigate(['/dashboard/customersupport/tickets/', newTicket.ticket_id], {replaceUrl: true});
    });
    //reset the form for the next ticket
    this.form.reset({emitEvent: true});
  }

  protected readonly config = config;
}
